import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class RemoverCursosAdmin extends Component {
 
  state = {
    curso:[],
    idcurso:null
  }
  
  
  componentDidMount(){
    this.loadcurso ();
  }
 

  async loadcurso () {

    const response = await api.post("/curso/id", { idcurso:this.props.match.params.idcurso });
    this.setState({
      curso:response.data,
      idcurso:response.data.id,
    })

  }




  onFormSubmit = async e =>{
    e.preventDefault() ;

    const { idcurso } = this.state;
      if (!idcurso) {
          this.setState({ error: "Não identificado o id do curso",
        success:null });
      } else {
      const response = await api.post("/admin/curso/del", { idcurso });
       

          if(response.data){
            this.setState({ success: "Curso Deletada!" , error:null, nome:null });


          this.props.history.push("/admin/cursos");
          }

      }
  }


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-6 p-4">     

        <h4>Excluir Cursos</h4>     
        <form  onSubmit={this.onFormSubmit}>
               
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" value={this.state.curso.nome} />
                </div>
                <div class="form-group">
                <button class="btn btn-danger mb-2">Excluir Curso</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(RemoverCursosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/removecurso.js